<template>
  <div class="auth-footer-btn d-flex justify-content-center">
    <template v-for="option in options">
      <b-button
        :key="option.provider"
        variant="outline-light"
        class="auth-btn mt-0"
        :disabled="loading"
        block
        @click="auth(option.provider)"
      >
        <b-spinner
          v-if="loading && provider === option.provider"
          variant="primary"
          type="grow"
          small
        />
        <apple-icon v-else-if="option.provider === 'apple'" />
        <img
          v-else
          :src="option.image"
          :alt="option.provider"
          :title="option.provider"
          width="21"
          height="21"
        >
      </b-button>
    </template>

    <component
      :is="SocialPhoneModal"
      v-if="phoneModal"
      v-model="phoneModal"
      @submitted="submit"
      @update:phone-number="phoneNumber = $event"
    />
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import * as AppleId from '@/plugins/appleid.auth.js'
import AppleIcon from '@/@okmenu/icons/AppleIcon'
import StorageService from '@/services/storage-service'
import MarketingService, { MARKETING_EVENTS } from '@/services/marketing-service'

const google = require('@/assets/images/auth/google.svg')
// const apple = require('@/assets/images/auth/apple.svg')
const facebook = require('@/assets/images/auth/facebook.svg')
const microsoft = require('@/assets/images/auth/microsoft.svg')

export default {
  name: 'SocialAuth',
  components: {
    AppleIcon,
    BButton,
    BSpinner,
  },
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  data() {
    return {
      SocialPhoneModal: null,
      loading: false,
      providerResponse: null,
      provider: '',
      phoneNumber: '',
      phoneModal: false,
      mustProvidePhone: false,
      /* eslint-disable global-require */
      options: [
        { image: google, provider: 'google' },
        // { image: apple, provider: 'apple' },
        { image: facebook, provider: 'facebook' },
        { image: microsoft, provider: 'microsoft' },
      ],
      /* eslint-enable global-require */
    }
  },
  computed: {
    shouldOpenPhoneModal() {
      return this.type === 'register' || this.mustProvidePhone
    },
  },
  mounted() {
    AppleId.auth.init({
      clientId: 'com.oktabletmenu.social-service',
      scope: 'name email',
      redirectURI: `${window.location.origin}/auth/apple/callback`,
      usePopup: true,
    })
  },
  methods: {
    auth(provider) {
      this.$emit('clear-error')
      this.provider = provider

      if (this.shouldOpenPhoneModal) {
        if (this.SocialPhoneModal) {
          this.phoneModal = true
          return
        }

        import(/* webpackChunkName: "phone-input" */ '@/views/auth/SocialPhoneModal')
          .then(module => {
            this.SocialPhoneModal = module.default
            this.$nextTick(() => { this.phoneModal = true })
          })
        return
      }
      this.submit()
    },
    submit() {
      this.loading = true
      const { provider } = this
      const api = this.provider === 'apple' ? AppleId.auth.signIn() : this.$auth.authenticate(provider)

      api
        .then(response => this.$store.dispatch('auth/socialLogin', { provider, providerResponse: response.authorization ?? response, phone: this.phoneNumber }))
        .then(() => {
          const pendingRoute = StorageService.getItem('okmenu_route_after_auth', null, -1)
          if (this.type === 'register' || this.mustProvidePhone) {
            MarketingService.triggerEvent(MARKETING_EVENTS.REGISTER_COMPLETE, 'auth', 'user registered')
            return this.$router.push(pendingRoute ?? { name: 'admin:welcome' })
          }
          return this.$router.push(pendingRoute ?? { name: 'admin:home' })
        })
        .catch(err => {
          if (err?.response?.status === 422 && !this.mustProvidePhone) {
            this.mustProvidePhone = true
            this.auth(provider)
          } else {
            this.emitError(err)
          }
        })
        .then(() => { this.loading = false })
    },
    emitError(error) {
      this.$notifyError(error)
      this.$emit('error', error)
    },
  },
}
</script>
